import { render, staticRenderFns } from "./adm.vue?vue&type=template&id=2614126d"
import script from "./adm.vue?vue&type=script&lang=js"
export * from "./adm.vue?vue&type=script&lang=js"
import style0 from "./adm.vue?vue&type=style&index=0&id=2614126d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports